import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-wrap: wrap;
`

const Grid = props => {
  const { children } = props
  return (
    <Wrapper>
      {children}
    </Wrapper>
  );
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/Layout/Grid.js